$(document).ready(() => {
  // Match the merchant's requested U+1D7E2 glyph for double zero.
  const orderPlayerNumber = (value) =>
    String(value).trim() === "00" ? "\u{1D7E2}\u{1D7E2}" : String(value).trim();

  
  const apiURL = "https://stimulus-athletic-app-wjngb.ondigitalocean.app";

  // ====FUNCTIONS BODIES AREA====

  const saveBulkSizesForCollection = (collectionId, payload) => {
    try {
      localStorage.setItem(
        `stimulus_bulk_sizes_${collectionId}`,
        JSON.stringify(payload)
      );
    } catch (e) {}
  };

  const getCollectionId = () =>  String($(".loadingPlayerSelectionPopup").data("collectionid") || "").trim();

  const getSavedPlayerForCollection = () => {
    const cid = getCollectionId();
    if (!cid) return null;

    try {
      const raw = localStorage.getItem(`stimulus_selected_player_main_v1_${cid}`);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  };

  function bulkCollectionPageATC() {
    const selectors = {
      cardRoot: ".mainProdThumbnail", // your product card wrapper
      checkbox: ".customCheckBoxContainer.productCardCheckBox",
      infoContainer: ".prodInfoContainer",
      variantDropdown: ".prodVariantsOptionsDropDown",
      variantOptions: ".variantDropDownOptions .dropdownOption",
      qtyDropdown: ".qtyDropdown",
      qtyOptions: ".qtyDropdown .dropdownOption",
      stickyBar: ".collectionPageATCBar",
      stickyCount: ".collectionPageATCBar .totalSelection",
      stickyPrice: ".collectionPageATCBar .totalSelectionPrice",
      bulkBtn: ".collectionPageATCBar .collectionBulkATC",
    };

    // ---- Helpers ----
    const formatMoney = (cents) => {
      // Use Shopify.formatMoney if present (most themes have it)
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        // If your theme defines a money format somewhere, it will use it.
        // Fallback string below is safe.
        try {
          return window.Shopify.formatMoney(
            cents,
            window.money_format || "${{amount}}"
          );
        } catch (e) {}
      }
      // fallback
      const val = (cents / 100).toFixed(2);
      return `$${val}`;
    };

    const getCardRootFromAnyChild = ($el) => $el.closest(selectors.cardRoot);

    const isSelected = ($root) =>
      $root.find(selectors.checkbox).hasClass("isSelected");

    const setSelected = ($root, selected) => {
      $root.find(selectors.checkbox).toggleClass("isSelected", !!selected);
    };

    const getVariantPayloadFromRoot = ($root) => {
      const $info = $root.find(selectors.infoContainer);
      const $variantDD = $info.find(selectors.variantDropdown);
      const $qtyDD = $info.find(selectors.qtyDropdown);

      const variantId = ($variantDD.attr("data-selectedoption") || "").trim();
      const qtyAttr =
        $qtyDD.attr("data-selectedoption") ||
        $qtyDD.attr("data-selectedOption") ||
        "1";

      const qty = parseInt(String(qtyAttr).trim(), 10) || 1;

      const priceCents =
        parseInt(($variantDD.attr("data-price-cents") || "0").trim(), 10) || 0;
      const variantImg = ($variantDD.attr("data-img") || "").trim();

      // player props
      const playerNumber = (
        $info.find(".playerNumberItem").text() || ""
      ).trim();
      const playerInital = (
        $info.find(".playerInitalItem").text() || ""
      ).trim();
      const playerDisplayName = (
        $info.find(".displayNameTxtElem").text() || ""
      )
        .trim()
        .toUpperCase();

      return {
        variantId,
        qty,
        priceCents,
        variantImg,
        playerNumber,
        playerInital,
        playerDisplayName,
        $info,
        $root,
      };
    };

    const validatePlayerRequirements = (payload) => {
      const $info = payload.$info;

      const needsName = $info.find(".hasName").length > 0;
      const needsNumber = $info.find(".hasNumber").length > 0;
      const needsInitial = $info.find(".hasInitial").length > 0;

      const missing = [];
      if (needsName && !payload.playerDisplayName) missing.push("Jersey name");
      if (needsNumber && !payload.playerNumber) missing.push("Player number");
      if (needsInitial && !payload.playerInital)
        missing.push("Player initial / number");

      return {
        ok: missing.length === 0,
        missing,
      };
    };

    const buildLineItemProperties = (payload) => {
      const properties = {};

      const cid = getCollectionId();
      if (cid) properties["_collectionID"] = String(cid);

      // team is required for FCFS; still safe to include for non-FCFS
      try {
        const rawTeam = localStorage.getItem(
          `stimulus_selected_team_main_v1_${cid}`
        );
        const teamObj = rawTeam ? JSON.parse(rawTeam) : null;
        const teamName = teamObj?.teamName
          ? String(teamObj.teamName).trim()
          : "";
        if (teamName && teamName !== "All Players")
          properties["_teamName"] = teamName;
      } catch (e) {}

      // keep playerId only when player-mode exists
      const savedPlayer = getSavedPlayerForCollection();
      if (savedPlayer?.id) properties["_playerId"] = String(savedPlayer.id);

      // existing fields
      if (payload.playerNumber && payload.playerNumber !== "N/A")
        properties["Player Number"] = orderPlayerNumber(payload.playerNumber);
      if (payload.playerInital && payload.playerInital !== "N/A")
        properties["Player Initial"] = payload.playerInital;
      if (payload.playerDisplayName && payload.playerDisplayName !== "N/A")
        properties["Display Name"] = payload.playerDisplayName;
      if (payload.variantImg) properties["_imgURL"] = payload.variantImg;

      return properties;
    };

    const collectSelectedItems = () => {
      const items = [];

      $(selectors.cardRoot).each(function () {
        const $root = $(this);
        if (!isSelected($root)) return;

        const payload = getVariantPayloadFromRoot($root);
        if (!payload.variantId) return;

        items.push(payload);
      });

      return items;
    };

    const updateStickyBar = () => {
      const COUNT_MODE = "units";
      const selected = collectSelectedItems();

      if (!selected.length) {
        $(selectors.stickyBar).hide();
        $(selectors.stickyCount).text("0 items");
        $(selectors.stickyPrice).text(formatMoney(0));
        return;
      }

      let totalCents = 0;
      selected.forEach((p) => {
        totalCents += (p.priceCents || 0) * (p.qty || 1);
      });

      const selectedProductsCount = selected.length;

      let totalUnitsCount = 0;
      selected.forEach((p) => {
        totalUnitsCount += p.qty || 1;
      });

      const displayCount =
        COUNT_MODE === "units" ? totalUnitsCount : selectedProductsCount;

      $(selectors.stickyBar).show();
      $(selectors.stickyCount).text(
        `${displayCount} item${displayCount === 1 ? "" : "s"}`
      );
      $(selectors.stickyPrice).text(formatMoney(totalCents));
    };

    const syncVariantDropdownSelectionToContainer = ($variantBtn) => {
      const $dd = $variantBtn.closest(selectors.variantDropdown);
      const variantId = String($variantBtn.data("option") || "").trim();
      const priceCents =
        parseInt(String($variantBtn.data("price-cents") || "0"), 10) || 0;
      const img = String($variantBtn.data("img") || "").trim();
      const title = $variantBtn.text().trim();

      // mark selected
      $variantBtn
        .addClass("selected")
        .siblings(".dropdownOption")
        .removeClass("selected");

      // write back to container attrs
      $dd.attr("data-selectedoption", variantId);
      $dd.attr("data-price-cents", priceCents);
      if (img) $dd.attr("data-img", img);

      // update visible label
      $dd.find(".selectedVariantOptionsTitle").text(title);
    };

    const syncQtyDropdownToContainer = ($qtyBtn) => {
      const $dd = $qtyBtn.closest(selectors.qtyDropdown);
      const qty = String($qtyBtn.data("option") || "1").trim();

      $qtyBtn
        .addClass("selected")
        .siblings(".dropdownOption")
        .removeClass("selected");

      $dd.attr("data-selectedoption", qty);
      $dd.attr("data-selectedOption", qty);
      $dd.find(".selectedOption").text(qty);
    };

    const bulkAddToCart = async () => {
      const selectedPayloads = collectSelectedItems();

      if (!selectedPayloads.length) return;

      // FCFS requires team selection
      try {
        const cid = getCollectionId();
        const endpoint = `${apiURL}/api/storefront-club-players?collectionId=${encodeURIComponent(
          cid
        )}`;
        const res = await fetch(endpoint);
        const data = await res.json();
        const fcfsEnabled = !!data?.firstComeFirstServe;

        if (fcfsEnabled) {
          const raw = localStorage.getItem(
            `stimulus_selected_team_main_v1_${cid}`
          );
          const teamObj = raw ? JSON.parse(raw) : null;
          const teamName = teamObj?.teamName
            ? String(teamObj.teamName).trim()
            : "";
          if (!teamName || teamName === "All Players") {
            alert("Please select a team before adding items to cart.");
            $(".openPlayerSelectionPopupBtn").first().trigger("click");
            return;
          }
        }
      } catch (e) {
        // if meta fetch fails, don’t hard-block
      }

      // Validate all selected items before adding
      const invalid = [];

      for (let i = 0; i < selectedPayloads.length; i++) {
        const p = selectedPayloads[i];
        const v = validatePlayerRequirements(p);

        if (!v.ok) {
          const productTitle = (
            p.$root.find(".card__title a").text() ||
            p.$root.find(".card__title").text() ||
            "This item"
          ).trim();

          invalid.push({
            title: productTitle,
            missing: v.missing,
            $root: p.$root,
          });
        }
      }

      if (invalid.length) {
        // Build proper English message
        const lines = invalid
          .map((x) => `• ${x.title}: ${x.missing.join(", ")}`)
          .join("\n");

        alert(
          "Before we can add these items to your cart, please complete the required personalization for the following selected products:\n\n" +
            lines +
            "\n\nTip: Click “Edit” on the item to fill in the missing details."
        );

        // scroll to first invalid item for good UX
        $("html, body").animate(
          { scrollTop: invalid[0].$root.offset().top - 120 },
          300
        );

        return;
      }

      // Build Shopify cart payload
      const items = selectedPayloads.map((p) => {
        const properties = buildLineItemProperties(p);
        const line = { id: p.variantId, quantity: p.qty };
        if (Object.keys(properties).length) line.properties = properties;
        return line;
      });

      // Disable button
      const $btn = $(selectors.bulkBtn);
      const originalHtml = $btn.html();
      $btn
        .prop("disabled", true)
        .addClass("disabledBtn")
        .html(`<span class="loadingIcon"></span>`);

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: JSON.stringify({ items }),
        contentType: "application/json",
        dataType: "json",
        success: function () {
          // You already have these helpers in theme:
          window.CartUI?.getCartCount?.($btn);
          window.CartUI?.refreshDrawerFromCartPage?.({ openAfter: true });

          if (
            typeof publish === "function" &&
            typeof PUB_SUB_EVENTS !== "undefined"
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
          }
        },
        error: function () {
          // restore button
          $btn
            .prop("disabled", false)
            .removeClass("disabledBtn")
            .html(originalHtml);
        },
        complete: function () {
          // restore button UI (success or fail)
          $btn
            .prop("disabled", false)
            .removeClass("disabledBtn")
            .html(originalHtml);
        },
      });
    };

    // ---- Events ----

    // Toggle selection via checkbox
    $(document).on("click", selectors.checkbox, function (e) {
      e.preventDefault();
      const $root = getCardRootFromAnyChild($(this));
      const currently = isSelected($root);
      setSelected($root, !currently);
      updateStickyBar();
    });

    // Variant dropdown option clicked
    $(document).on("click", selectors.variantOptions, function () {
      const $btn = $(this);
      syncVariantDropdownSelectionToContainer($btn);
      updateStickyBar();
    });

    // Qty dropdown option clicked
    $(document).on("click", selectors.qtyOptions, function () {
      const $btn = $(this);
      syncQtyDropdownToContainer($btn);
      updateStickyBar();
    });

    // Bulk ATC click
    $(document).on("click", selectors.bulkBtn, function () {
      bulkAddToCart();
    });

    const observeQtyChanges = () => {
      const targets = document.querySelectorAll(".qtyDropdown");
      if (!targets.length) return;

      const obs = new MutationObserver(() => {
        // call your existing update
        updateStickyBar();
      });

      targets.forEach((el) => {
        obs.observe(el, {
          attributes: true,
          attributeFilter: ["data-selectedoption", "data-selectedOption"],
        });
      });
    };

    // call this once after updateStickyBar() initial load
    observeQtyChanges();

    // Initial compute on load
    updateStickyBar();
  }

  function uniformSizesPopup() {
    const sel = {
      popup: ".allSizesPopupContainer",
      openBtn: ".selectAllSizes",
      closeElems: ".popupClosingElem, .closeBtnItem",
      loader: ".allSizesPopupContainer .loadingAnim",
      actions: ".allSizesPopupContainer .allSizesSelectionArea",

      topsArea: ".allSizesPopupContainer .topsProductsSizesArea",
      bottomsArea: ".allSizesPopupContainer .sizesForAllBottoms",
      topsDD: ".allSizesPopupContainer .sizesForAllTops",
      bottomsDD: ".allSizesPopupContainer .sizesForAllBottoms",
      socksDD: ".allSizesPopupContainer .sizesForAllSocks",

      topsList: ".allSizesPopupContainer .allTopsSizesBtns",
      bottomsList: ".allSizesPopupContainer .allBottomsSizesBtns",
      socksList: ".allSizesPopupContainer .allSocksSizesBtns",

      applyBtn: ".allSizesPopupContainer .applyAllSizes",

      // collection card selectors (same as your bulk code)
      cardRoot: ".mainProdThumbnail",
      title: ".card__title a",
      variantBtn: ".variantDropDownOptions .dropdownOption",
      variantDD: ".prodVariantsOptionsDropDown",
    };

    // --- Keyword rules (edit these as you want) ---
    const categoryMatchers = [
      { key: "tops", test: (t) => /jersey|top|shirt|tee/i.test(t) },
      { key: "bottoms", test: (t) => /shorts|bottom|pant|trouser/i.test(t) },
      { key: "socks", test: (t) => /sock/i.test(t) },
    ];

    const normalize = (str) =>
      String(str || "")
        .replace(/\s+/g, " ")
        .replace(/\u00a0/g, " ")
        .trim()
        .toLowerCase();

    const detectCategory = ($card) => {
      const titleText = normalize($card.find(sel.title).text());
      for (const rule of categoryMatchers) {
        if (rule.test(titleText)) return rule.key;
      }
      return "other";
    };

    const getFirstCardOfCategory = (categoryKey) => {
      let found = null;
      $(sel.cardRoot).each(function () {
        const $card = $(this);
        if (detectCategory($card) === categoryKey) {
          found = $card;
          return false;
        }
      });
      return found;
    };

    const extractVariantButtonsFromCard = ($card) => {
      const list = [];
      $card.find(sel.variantBtn).each(function () {
        const $btn = $(this);
        list.push({
          title: normalize($btn.text()),
          label: $btn.text().trim(),
          optionId: String($btn.attr("data-option") || "").trim(),
          price: String($btn.attr("data-price") || "").trim(),
          priceCents: String($btn.attr("data-price-cents") || "").trim(),
          img: String($btn.attr("data-img") || "").trim(),
        });
      });
      return list;
    };

    const renderPopupOptions = ($targetList, variantList) => {
      $targetList.empty();

      variantList.forEach((v, idx) => {
        const btn = `
          <button
            type="button"
            class="dropdownOption ${idx === 0 ? "selected" : ""}"
            data-option="${v.optionId}"
            data-price="${v.price}"
            data-price-cents="${v.priceCents}"
            data-img="${v.img}"
            data-label="${$("<div>").text(v.label).html()}"
            data-title="${$("<div>").text(v.title).html()}"
          >${v.label}</button>
        `;
        $targetList.append(btn);
      });
    };

    const setPopupSelectedLabel = ($wrapper, label) => {
      $wrapper.find(".dropDownSelectedLabel").text(label || "Select Sizes");
    };

    const openPopup = () => {
      const $popup = $(sel.popup);
      $popup.addClass("isOpen");
      $(sel.loader).show();
      $(sel.actions).hide();

      // hide all category areas by default
      // (your markup reuses .topsProductsSizesArea class for tops/bottoms sections, so just use container wrappers)
      $popup.find(".topsProductsSizesArea").hide();
      $popup.find(".bottomsProductsSizesArea").hide();
      $popup.find(".socksProductsSizesArea").hide();

      // Build content after a tick so loader can display
      setTimeout(() => {
        buildPopupContent();
        $(sel.loader).hide();
        $(sel.actions).show();
      }, 0);
    };

    const closePopup = () => {
      $(sel.popup).removeClass("isOpen");
    };

    const buildPopupContent = () => {
      const $popup = $(sel.popup);

      // TOPS
      const $topsCard = getFirstCardOfCategory("tops");
      if ($topsCard) {
        const topsVariants = extractVariantButtonsFromCard($topsCard);
        if (topsVariants.length) {
          $popup.find(".topsProductsSizesArea").first().show(); // first block is tops in your HTML
          renderPopupOptions($(sel.topsList), topsVariants);
          setPopupSelectedLabel($(sel.topsDD), topsVariants[0].label);
        }
      } else {
        $(sel.topsList).empty();
      }

      // BOTTOMS
      const $bottomsCard = getFirstCardOfCategory("bottoms");
      if ($bottomsCard) {
        const bottomsVariants = extractVariantButtonsFromCard($bottomsCard);
        if (bottomsVariants.length) {
          // your second block is also "topsProductsSizesArea" (typo), so we show by index:
          $popup.find(".bottomsProductsSizesArea").show();
          renderPopupOptions($(sel.bottomsList), bottomsVariants);
          setPopupSelectedLabel($(sel.bottomsDD), bottomsVariants[0].label);
        }
      } else {
        $(sel.bottomsList).empty();
      }

      // SOCKS (optional)
      const $socksCard = getFirstCardOfCategory("socks");
      if ($socksCard && $(sel.socksList).length) {
        const socksVariants = extractVariantButtonsFromCard($socksCard);
        if (socksVariants.length) {
          $popup.find(".socksProductsSizesArea").show();
          renderPopupOptions($(sel.socksList), socksVariants);
          setPopupSelectedLabel($(sel.socksDD), socksVariants[0].label);
        }
      } else {
        $(sel.socksList).empty();
      }
    };

    // Popup dropdown open/close
    // $(document).on("click", `${sel.popup} .dropdownOpenerBtn`, function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   const $wrapper = $(this).closest(".customDropDownWrapper");
    //   toggleDropdown($wrapper);
    // });

    const toggleDropdown = ($wrapper) => {
      const isOpen = $wrapper.hasClass("open");

      closeAllDropdowns();

      if (!isOpen) {
        $wrapper.addClass("open");
        $wrapper
          .find(".dropDownContentWrapper")
          .stop(true, true)
          .slideDown(300);
      }
    };

    const closeAllDropdowns = () => {
      $(".customDropDownWrapper")
        .removeClass("open")
        .find(".dropDownContentWrapper")
        .slideUp(300);
    };

    // Selecting an option inside popup
    $(document).on(
      "click",
      `${sel.popup} .dropDownContentWrapper .dropdownOption`,
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        const $wrap = $btn.closest(".customDropDownWrapper");
        $btn.addClass("selected").siblings().removeClass("selected");
        setPopupSelectedLabel($wrap, $btn.text().trim());
        closeAllDropdowns();
      }
    );

    // Apply sizes to all products on page
    const applyToCategory = (categoryKey, selectedPayload) => {
      if (!selectedPayload?.labelNorm) return;

      $(sel.cardRoot).each(function () {
        const $card = $(this);
        if (detectCategory($card) !== categoryKey) return;

        let $match = null;
        $card.find(sel.variantBtn).each(function () {
          const $vb = $(this);
          const labelNorm = normalize($vb.text());
          if (labelNorm === selectedPayload.labelNorm) {
            $match = $vb;
            return false;
          }
        });

        if ($match && $match.length) $match.trigger("click");
      });
    };

    $(document).on("click", sel.applyBtn, function () {
      const collectionId = String(
        $(sel.popup).data("collectionid") || ""
      ).trim();
      if (!collectionId) {
        console.log(`collectionId ${collectionId}`);
        console.warn("⚠️ collectionId missing on allSizesPopupContainer");
        closePopup();
        return;
      }

      const getSelectedVariantPayload = ($list) => {
        const $opt = $list.find(".dropdownOption.selected").first();
        if (!$opt.length) return null;

        return {
          optionId: String($opt.attr("data-option") || "").trim(),
          label: String($opt.text() || "").trim(),
          labelNorm: normalize($opt.text()),
        };
      };

      const topsSelected = getSelectedVariantPayload($(sel.topsList));
      const bottomsSelected = getSelectedVariantPayload($(sel.bottomsList));
      const socksSelected = $(sel.socksList).length
        ? getSelectedVariantPayload($(sel.socksList))
        : null;

      // ✅ Apply to collection cards (optional)
      applyToCategory("tops", topsSelected);
      applyToCategory("bottoms", bottomsSelected);
      if ($(sel.socksList).length) applyToCategory("socks", socksSelected);

      // console.log(`topsSelected ${topsSelected}`);
      // console.log(`bottomsSelected ${bottomsSelected}`);
      // console.log(`socksSelected ${socksSelected}`);

      // ✅ Save for product page preselection (ID + label)
      saveBulkSizesForCollection(collectionId, {
        tops: topsSelected || null,
        bottoms: bottomsSelected || null,
        socks: socksSelected || null,
      });

      closePopup();
    });

    // Open / Close wiring
    $(document).on("click", sel.openBtn, function () {
      openPopup();
    });

    $(document).on("click", sel.closeElems, function () {
      closePopup();
    });
  }

  // FUNCTIONS CALLING AREA====
  bulkCollectionPageATC();
  uniformSizesPopup();
});
